import script from "./DraftEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./DraftEditor.vue?vue&type=script&setup=true&lang=js"

import "./DraftEditor.vue?vue&type=style&index=0&id=0cca917a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cca917a"]])

export default __exports__